import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import BillingPage from "./components/BillingPage/BillingPage";
import Dashboard from "./components/Dashboard/Dashboard";
import HomePage from "./components/HomePage/HomePage";
import DashboardLayoutRoute from "./routes/DashboardLayoutRoute";
import CalendarPageRoute from "./routes/CalendarPageRoute";
import LoginPageRoute from "./routes/LoginPageRoute";
import MarketingLayout from "./components/MarketingLayout/MarketingLayout";
import PricingPage from "./components/PricingPage/PricingPage";
import PrivacyPage from "./components/PrivacyPage/PrivacyPage";
import RaiseTicketPage from "./components/RaiseTicketPage/RaiseTicketPage";
import TermsPage from "./components/TermsPage/TermsPage";
import UsagePage from "./components/UsagePage/UsagePage";
import "./App.scss";

interface AppProps {}

interface AppState {}

class App extends Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
    this.state = {};
  }

  render(): React.JSX.Element {
    return (
      <div className="app">
        <Routes>
          <Route element={<MarketingLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/raise-ticket" element={<RaiseTicketPage />} />
          </Route>

          <Route path="/dashboard" element={<DashboardLayoutRoute />}>
            <>
              <Route index element={<Dashboard />} />
              <Route path="login" element={<LoginPageRoute />} />
              <Route path="calendar" element={<CalendarPageRoute />} />
              <Route path="usage" element={<UsagePage />} />
              <Route path="billing" element={<BillingPage />} />
            </>
          </Route>

          <Route path="/m/dashboard" element={<DashboardLayoutRoute />}>
            <>
              <Route index element={<Navigate to="overview" replace />} />
              <Route path="overview" element={<Dashboard />} />
              <Route path="login" element={<LoginPageRoute />} />
              <Route path="calendar" element={<CalendarPageRoute />} />
              <Route path="usage" element={<UsagePage />} />
              <Route path="billing" element={<BillingPage />} />
            </>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    );
  }
}

export default App;
